import tinycolor from 'tinycolor2';
import {} from '@material-ui/core/styles';

// const primary = "#3D3834";
const primary = '#262626';
const secondary = '#11B2A2';

const warning = '#FFC260';
const success = '#3CD4A0';
const info = '#9013FE';
const danger = '#721c24';

const lightenRate = 7.5;
const darkenRate = 15;

const palette = {
	primary: {
		main: primary,
		light: tinycolor(primary).lighten(lightenRate).toHexString(),
		dark: tinycolor(primary).darken(darkenRate).toHexString(),
		contrastText: '#FFFFFF',
	},
	secondary: {
		main: secondary,
		light: tinycolor(secondary).lighten(lightenRate).toHexString(),
		dark: tinycolor(secondary).darken(darkenRate).toHexString(),
		contrastText: '#FFFFFF',
	},
	warning: {
		main: warning,
		light: tinycolor(warning).lighten(lightenRate).toHexString(),
		dark: tinycolor(warning).darken(darkenRate).toHexString(),
	},
	success: {
		main: success,
		light: tinycolor(success).lighten(lightenRate).toHexString(),
		dark: tinycolor(success).darken(darkenRate).toHexString(),
	},
	info: {
		main: info,
		light: tinycolor(info).lighten(lightenRate).toHexString(),
		dark: tinycolor(info).darken(darkenRate).toHexString(),
	},
	danger: {
		main: danger,
		light: tinycolor(danger).lighten(lightenRate).toHexString(),
		dark: tinycolor(danger).darken(darkenRate).toHexString(),
	},
};

export default palette;
